var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.67,28.43v3.38a15.67,15.67,0,0,1-31.34,0V28.43",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.51,
    y: 6.45,
    width: 18.44,
    height: 34.22,
    rx: 8.89,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.73,
    y1: 57.34,
    x2: 31.73,
    y2: 47.71,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.14,
    y1: 57.55,
    x2: 26.43,
    y2: 57.55,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.4f75cc30a88f2a5207efd74868ec21bb.svg";
export { ForwardRef as ReactComponent };